/**
 * Rewrites a Xero dashboard URL to include org-switching logic.
 * If VITE_XERO_ORG_SHORTCODE is set, the URL will force-switch to the
 * correct Xero org before opening the invoice/resource.
 *
 * If the shortcode is not set or the URL is not a go.xero.com URL,
 * the original URL is returned unchanged.
 */
export function getOrgAwareXeroUrl(xeroUrl: string): string {
  const shortcode = import.meta.env.VITE_XERO_ORG_SHORTCODE;
  if (!shortcode || !xeroUrl.includes('go.xero.com')) {
    return xeroUrl;
  }

  try {
    const url = new URL(xeroUrl);
    const path = url.pathname + url.search;
    return `https://go.xero.com/organisationlogin/default.aspx?shortcode=${encodeURIComponent(shortcode)}&redirecturl=${encodeURIComponent(path)}`;
  } catch {
    return xeroUrl;
  }
}
